import { VideoSizes } from '@anm/hosting-player';
import { FC, MouseEvent, useCallback, useRef } from 'react';

import { PlayerBlockProps } from '../..';
import PlayerStatuses from '../../PlayerStatuses';
import { PlayerStatusesWrapper } from '../../Wrapper';

import ActionsBlock from './ActionsBlock';
import Player from './Player';
import Wrapper, { LeftSide, RightSide, Title } from './Wrapper';

export type ProjectPreviewProps = Pick<
  PlayerBlockProps,
  | 'width'
  | 'height'
  | 'hostedId'
  | 'actions'
  | 'title'
  | 'preview'
  | 'statuses'
  | 'renderEditLink'
  | 'renderEmbedLink'
  | 'renderLandingLink'
  | 'renderPermissionLink'
> & {
  closeModal: () => void;
  renderVideoPlayer?: (sizes?: VideoSizes) => JSX.Element;
};

const CONTENT_CLASSNAME = 'content';

const ProjectPreview: FC<ProjectPreviewProps> = ({
  width,
  height,
  title,
  actions,
  preview,
  hostedId,
  statuses,
  closeModal,
  renderPermissionLink,
  renderEditLink,
  renderEmbedLink,
  renderLandingLink,
  renderVideoPlayer
}) => {
  const container = useRef<HTMLDivElement>(null);

  const onWrapperClick = useCallback((e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    const canCloseModal =
      !(e.target as HTMLElement).classList.contains(CONTENT_CLASSNAME) &&
      !(e.target as HTMLElement).closest(`.${CONTENT_CLASSNAME}`);

    canCloseModal && closeModal();
  }, []);

  return (
    <Wrapper onClick={onWrapperClick}>
      <LeftSide ref={container}>
        <div className={CONTENT_CLASSNAME}>
          <Player {...{ width, height, container, renderVideoPlayer }} imageSrc={preview} />
        </div>
      </LeftSide>
      <RightSide className={CONTENT_CLASSNAME}>
        <Title>{title}</Title>
        {statuses && (
          <PlayerStatusesWrapper>
            <PlayerStatuses
              statuses={statuses}
              {...{
                hostedId,
                renderEditLink,
                renderEmbedLink,
                renderLandingLink,
                renderPermissionLink
              }}
            />
          </PlayerStatusesWrapper>
        )}
        <ActionsBlock actions={actions} closeModal={closeModal} />
      </RightSide>
    </Wrapper>
  );
};

export default ProjectPreview;
